var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.15,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.61 7.761c0 2.013-1.419 3.227-3.403 3.227a2.917 2.917 0 0 1-2.341-.857 3.006 3.006 0 0 1-.855-2.37c0-1.118.893-2.41 1.997-2.41h3.404c.66 0 1.199.929 1.199 1.6v.81zM9.39 7.761c0 2.013 1.417 3.227 3.403 3.227a2.918 2.918 0 0 0 2.34-.857c.618-.623.93-1.49.856-2.37 0-1.118-.895-2.41-1.997-2.41h-3.404c-.663 0-1.199.929-1.199 1.6v.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61 6.951v-.736A1.411 1.411 0 0 1 8 5c.696 0 1.287.517 1.39 1.215v.736"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.d45a210778df3e1a85e2740e151856ed.svg";
export { ForwardRef as ReactComponent };